import { CPT_FLAG_ORDER } from './flag-descriptors';

export const ATTR_KEYS = [
  'description',
  'duration',
  'rate',
  'callToBook',
  'requireCreditCardForNewClients',
];

const FLAG_DISPLAY_ORDER = [...CPT_FLAG_ORDER, 'description'];

function readAttr(code, key) {
  if (code && typeof code.get === 'function') {
    return code.get(key);
  }
  return code?.[key];
}

export function cptCodeAttrsFromRecord(code) {
  let attrs = {};

  for (let key of ATTR_KEYS) {
    attrs[key] = readAttr(code, key);
  }

  return attrs;
}

function normalizeComparable(value) {
  if (value === null || value === undefined) {
    return '';
  }
  if (typeof value === 'boolean') {
    return String(value);
  }

  return String(value).trim().toLowerCase();
}

function normalizeForAttrKey(key, value) {
  if (key === 'duration' || key === 'rate') {
    let number = Number(value);
    return Number.isNaN(number) ? '' : String(number);
  }

  return normalizeComparable(value);
}

export function attrsEqualKey(key, left, right) {
  return normalizeForAttrKey(key, left) === normalizeForAttrKey(key, right);
}

export function attrSignature(attrs) {
  return ATTR_KEYS.map(key => `${key}:${normalizeForAttrKey(key, attrs[key])}`).join('\x1f');
}

export function cptCodeSignature(record) {
  return attrSignature(cptCodeAttrsFromRecord(record));
}

export function normalizeDescriptionKey(description) {
  return String(description ?? '')
    .trim()
    .toLocaleLowerCase();
}

function numericSortValue(value, fallback = Number.POSITIVE_INFINITY) {
  if (value === null || value === undefined || String(value).trim() === '') {
    return fallback;
  }
  let number = Number(value);
  return Number.isNaN(number) ? fallback : number;
}

export function compareCollapsedRows(left, right) {
  let leftRate = numericSortValue(left.attrs.rate, Number.POSITIVE_INFINITY);
  let rightRate = numericSortValue(right.attrs.rate, Number.POSITIVE_INFINITY);
  if (leftRate !== rightRate) {
    return leftRate - rightRate;
  }

  let leftDuration = numericSortValue(left.attrs.duration, Number.POSITIVE_INFINITY);
  let rightDuration = numericSortValue(right.attrs.duration, Number.POSITIVE_INFINITY);
  if (leftDuration !== rightDuration) {
    return leftDuration - rightDuration;
  }

  return String(left.attrs.description ?? '').localeCompare(
    String(right.attrs.description ?? ''),
    undefined,
    {
      sensitivity: 'base',
    }
  );
}

export function sortFlaggedKeys(keys) {
  let order = new Map(FLAG_DISPLAY_ORDER.map((key, index) => [key, index]));
  return [...keys].sort((left, right) => (order.get(left) ?? 99) - (order.get(right) ?? 99));
}
